export const BLOG_COUNT = "BLOG_COUNT";
export const ALL_BLOG_IMAGES = "ALL_BLOG_IMAGES";
export const SEL_BLOG_IMAGES = "SEL_BLOG_IMAGES";
